import { extendTheme } from "@chakra-ui/react";

/**
 * Theme of the order cards and what opens from them (supplier discovery and
 * its estimate modal). Anything rendered outside a card that must look the
 * same, like the final estimate review modal, uses it too.
 */
export const orderCardTheme = extendTheme({
  components: {
    Text: {
      baseStyle: {
        fontSize: "small",
      },
    },
  },
});
